import { CHAT_COMPLETED_TYPE, CHAT_RECEIVE_MESSAGE_TYPE } from 'components/Chat/chatConstants';
import { getAiChatPayload } from 'components/Chat/chatHelpers';
import { useWebsocket } from 'contexts/websocket';
import { useEffect } from 'react';

const useCompletedChatMessage = (onCompleted) => {
    const { onMessage } = useWebsocket();

    useEffect(() => {
        if (!onCompleted) return;

        const cleanup = onMessage((websocketMessage) => {
            if (websocketMessage.type !== CHAT_COMPLETED_TYPE && websocketMessage.type !== CHAT_RECEIVE_MESSAGE_TYPE) {
                return;
            }

            const payload = getAiChatPayload(websocketMessage);
            if (websocketMessage.type === CHAT_RECEIVE_MESSAGE_TYPE && !payload.done) return;

            onCompleted(payload, websocketMessage);
        });

        return cleanup;
    }, [onCompleted, onMessage]);
};

export default useCompletedChatMessage;
